import React, { createContext, useState, useEffect, useRef } from 'react';
import axios from 'axios';

import { API_BASE_URL } from '../constants';
import { cartConfig } from '../utils/cartApi';
import { AUTH_CHANGED } from '../utils/auth';
export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);
  const [total, setTotal] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  // Fetch cart items
  useEffect(() => {
    const fetchCart = async () => {
      try {
        const cartRes = await axios.get(`${API_BASE_URL}/cart/`, await cartConfig());
          setCart(cartRes.data);
      } catch (error) {
        console.error("Error fetching cart:", error);
      }
    };
    fetchCart();
    // signing in shows the account's cart (from any device); signing out
    // shows this browser's guest cart
    window.addEventListener(AUTH_CHANGED, fetchCart);
    return () => window.removeEventListener(AUTH_CHANGED, fetchCart);
  }, []);


  // Calculate total
useEffect(() => {
  let totalPrice = 0;
  let totalItemCount = 0;

  for (let i = 0; i < cart.length; i++) {
    totalPrice += Number(cart[i].total_price || 0);
    totalItemCount += cart[i].quantity;
  }

  setTotal(totalPrice);
  setTotalItems(totalItemCount);
}, [cart]);

   //increase item quantity
   const incQuant = async (cartItem) => {
    try {
      const newQuantity = cartItem.quantity + 1;

      const res = await axios.patch(`${API_BASE_URL}/cart/${cartItem.id}/`, { quantity: newQuantity }, await cartConfig());
      const updatedCart = cart.map(item => item.id === cartItem.id ? res.data : item);
      setCart(updatedCart);
    } catch (error) {
      console.error("Error increasing quantity:", error);
    }
  };
  
  //decrease item quantity
  const decQuant = async (cartItem) => {

    // going below one removes the line
    if (cartItem.quantity <= 1) {
      try {
        await axios.delete(`${API_BASE_URL}/cart/${cartItem.id}/`, await cartConfig());
        setCart(cart.filter(item => item.id !== cartItem.id));
      } catch (error) {
        console.error("Error deleting item:", error);
        alert("Could not remove item");
      }
      return;
    }
    try {
      const newQuantity = cartItem.quantity - 1;
      const res = await axios.patch(`${API_BASE_URL}/cart/${cartItem.id}/`, { quantity: newQuantity }, await cartConfig());
      const updatedCart = cart.map(item => item.id === cartItem.id ? res.data : item);
      setCart(updatedCart);
    } catch (error) {
      console.error("Error increasing quantity:", error);
    }
  };
  const removeFromCart = async (cartItem) => {
    try {
      await axios.delete(`${API_BASE_URL}/cart/${cartItem.id}/`, await cartConfig());
      setCart(cart.filter(item => item.id !== cartItem.id));
    } catch (error) {
      console.error("Error removing item:", error);
      alert("Could not remove item");
    }
  };

  const toastTimer = useRef(null);
  const triggerToast = (message, duration = 3000) => {
    setToastMessage(message);
    setShowToast(true);
    // a new toast restarts the timer instead of being cut short by the old one
    clearTimeout(toastTimer.current);
    toastTimer.current = setTimeout(() => {
      setShowToast(false);
    }, duration);
  };
  return (
    <CartContext.Provider value={{ cart, setCart, total, incQuant, decQuant, removeFromCart, totalItems , triggerToast}}>
      {children}
      {showToast && (
      <div className="toast-container">
        <div className="toast-message">{toastMessage}</div>
      </div>
    )}


    </CartContext.Provider>
  );
};